import ListingImageGallery from './ListingImageGallery/ListingImageGallery';

import css from './ListingPage.module.css';

const SectionGallery = props => {
  const { listing, variantPrefix } = props;
  const images = listing.images;

 
  const imageVariants = ['scaled-xlarge', 'scaled-large', 'scaled-medium', 'default'];
  const thumbnailVariants = ['scaled-small', 'scaled-medium', variantPrefix];
  return (
    <section className={css.productGallery} data-testid="carousel">
      <ListingImageGallery
        images={images}
        imageVariants={imageVariants}
        thumbnailVariants={thumbnailVariants}
      />
    </section>
  );
};

export default SectionGallery;
